import React, { useCallback, useEffect, useMemo, useState } from 'react';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, SimpleItem, Label } from "devextreme-react/form";
import IClient from "../../models/IClient";
import { FormListBase, FormListBaseTab, FormListBaseGrid } from '../base';
import { Button } from 'devextreme-react';
import useCustomDataSource, { Mode } from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';

export default function GestionCorrectionVilles() {
  const clientFormDataSource = useCustomDataSource<IClient, IClient>({ path: "client", primaryKey: "idClient", customReadAllPath: "client/read-list" });
  const { selectedDataRow: selectedClient, mode, setMode, isFieldModifier, setIsFieldModifier } = clientFormDataSource;
  const villes = [""];

  return (
    <FormListBase data={clientFormDataSource} width="600px">
      <FormListBaseGrid dataSource={clientFormDataSource.dataSource}>
        <Column key={"grid-col-nom"} dataField={"nom"} caption="Nom" allowHiding={false} />
        <Column key={"grid-col-prenom"} dataField={"prenom"} caption="Prénom" allowHiding={false} />
        <Column key={"grid-col-adresse"} dataField={"adresse"} caption="Adresse" allowHiding={false} />
      </FormListBaseGrid>
      <FormListBaseTab>
        <TabItem title="Informations">
          <Form readOnly={mode == Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedClient || {} as IClient} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
            <SimpleItem key={"frm-lbl"}>
              <label>La liste suivante affiche le nom des villes du Québec qui ne correspondent pas aux codes postaux.</label>
              <span style={{ position: "relative", float: "right" }}>
                <span>
                  <Button text={"Sélectionner tout"} />
                </span>
                <span style={{ marginLeft: "1em" }}>
                  <Button text={"Désélectionner tout"} />
                </span>
              </span>
            </SimpleItem>
            <SimpleItem key={"frm-rechercher"} dataField={""}>
              <Label text={"Rechercher"} />
            </SimpleItem>
            <SimpleItem key={"frm-b1"}>
              <span style={{ marginRight: "1em" }}>
                <Button text={"Trouver"} />
              </span>
              <span>
                <Button text={"Effacer"} />
              </span>
            </SimpleItem>
            <GroupItem>
              <DataGrid showBorders={true} allowColumnResizing={true}>
                <Column caption={"Client"} />
                <Column caption={"Code postal"} />
                <Column caption={"Ville"} />
                <Column caption={"Ville proposée"} />
                <Column caption={""} width={"3em"} />
              </DataGrid>
            </GroupItem>
          </Form>
        </TabItem>
        <TabItem title="Système"><FormSysteme formData={selectedClient || {} as IClient} /></TabItem>
      </FormListBaseTab>
    </FormListBase>
  );
}
